import React, { useState, useEffect, useRef, useMemo } from "react";
import { Table, Tooltip, Spin, Checkbox, Space, message, Button } from "antd";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { formatIndianDate } from "../../utils/Constant";
import CustomSearch from "../../components/search/CustomSearch";
import { capitalizeAndRemoveUnderscores, downloadFile, limitWords, } from "../../utils/utils";
import EditorSwitch from "../../components/editorSwitch";
import Pnation from "../../components/Pagination/pagination";
import Papa from 'papaparse';
import { DownloadOutlined, MailOutlined, FilterOutlined } from '@ant-design/icons';
import MotionIconButton from "../../components/icons/MotionIcon";
import axiosInstance from "../../utils/axiosInstance";
import { useSelector } from "react-redux";
import { useTheme } from "../../utils/themeToggle/theme";
import AdvancedSearchForm from "../../components/search/AdvanceSearch";
import BoldPlusIcon from "../../components/icons/BoldPlusIcon";

function FreshRequest() {
  const [isLoading, setIsloading] = useState(false);
  let [request, setRequest] = useState(false);
  const params = useParams();
  const navigate = useNavigate()
  const location = useLocation();
  const data = location?.state?.label;
  const isFromAnaltticData = location?.state?.status ? true : false;
  const [searchKeyword, setSearchKeyword] = useState({ search_keyword: '', is_active: "True", status: params?.status?.toUpperCase(), is_editor: false });
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const state = location.state;
  const companyId = localStorage.getItem("companyId");
  const comp_id = useSelector((store) => store.auth.userInfo.company_id);
  const { darkMode } = useTheme();

  const [searchFields, setSearchFields] = useState({
    first_name: '',
    created_at: null,
    agreement_type: '',
    name_of_client: '',
    nature: '',
    status: '',
    effective_date: null,
    execution_date: null,
    tenure: '',
    termination_notice: '',
    invoice_frequency: '',
    invoice_date: null,
    credit_term: '',
    contract_currency_value: '',
    contract_currency: '',
    value: '',
    custom_field: '',
    product_name: ''
  });
  const childRef = useRef();
  const [listingUrl, setListingUrl] = useState('')
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const handleDataFromChild = () => {
    return childRef.current?.getPayload();
  };
  const getSearchFilters = () => {
    return Object.entries(searchFields)
      .filter(([_, value]) => value !== null && value !== '')
      .map(([key, value]) => ({
        key,
        value: value?.format ? value.format('DD-MM-YYYY') : value,
      }));
  };
  const handleAdvanceSearch = async () => {
    const filters = getSearchFilters();
    const payload = {
      search_keyword: searchKeyword.search_keyword,
      search_filters: filters,
      is_active: "True",
      is_editor: searchKeyword.is_editor || false,
      page_number: 1,
      page_size: 10,
    };

    setIsloading(true);
    try {
      const res = await axiosInstance.post("/contract/search_spcial/", payload);
      
      setRequest(res?.data?.results || []);
      setListingUrl("");
      setIsFilterOpen(false);
    } catch (error) {
      message.error("Failed to fetch search results");
      console.error(error);
    } finally {
      setIsloading(false);
    }
  };

  const handleViewDetails = async (record) => {
    if (!record.is_read) {
      await axiosInstance.put(`/contract/update-read-or-unread-agreement/`, {
        agreement_ids: [record.id],
        read_status: true,
        company_id: companyId || comp_id,
      });

    } else {
    }
    navigate(
      companyId
        ? `/admin/company/${companyId}/contracts/${record.id}`
        : `/admin/contracts/${record.id}`
    );

  };
  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      const allRowKeys = request?.map((item) => item.id);
      setSelectedRowKeys(allRowKeys);
    } else {
      setSelectedRowKeys([]);
    }
  };
  const handleIconClick = async () => {
    try {
      const response = await axiosInstance.put(`/contract/update-read-or-unread-agreement/`, {
        agreement_ids: selectedRowKeys,
        read_status: false,
        company_id: companyId || comp_id,
      });

      if (response.status === 200) {
        setSearchKeyword({ ...searchKeyword })
        setSelectedRowKeys([]);
      }
    } catch (error) {
      setSelectedRowKeys([]);
    }
  };

  const getTextStyle = (record, darkMode) => {
    if (darkMode) {
      return {
        color: record.is_read ? "#B0B0B0" : "#FFFFFF", // read = light gray, unread = white
        fontWeight: record.is_read ? "normal" : "bold",
      };
    } else {
      return {
        color: "#000000", // black
        fontWeight: record.is_read ? "normal" : "bold",
      };
    }
  };



  const columns = useMemo(() => [
    {
      title: (
        <Checkbox
          indeterminate={
            selectedRowKeys.length > 0 &&
            request?.length &&
            selectedRowKeys.length < request.length
          }
          checked={request?.length && selectedRowKeys.length === request.length}

          onChange={handleSelectAllChange}
          onClick={(e) => e.stopPropagation()}
        />
      ),
      dataIndex: "checkbox",
      width: 15,
      render: (_, record) => (
        <Checkbox
          checked={selectedRowKeys.includes(record.id)}
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => {
            if (e.target.checked) {
              setSelectedRowKeys([...selectedRowKeys, record.id]);
            } else {
              setSelectedRowKeys(
                selectedRowKeys.filter((key) => key !== record.id)
              );
            }
          }}
        />
      ),
    },
    {
      title: "User Name",
      dataIndex: "user_name",
      width: 50,
      ellipsis: true,
      render: (userName, record) => {
        return (
          <span
            style={getTextStyle(record, darkMode)}
          >
            {userName}
          </span>
        );
      },
    },
        {
      title: (
        <Tooltip className="whitespace-nowrap" title="Contributor">
          Contributor
        </Tooltip>
      ),
      dataIndex: "editable_username",
      width: 60,
      ellipsis: true,
      render: (text, record) => {
        return (
          <span style={getTextStyle(record, darkMode)}>
            {text && text.charAt(0).toUpperCase() + text.slice(1)}
          </span>
        );
      },
    },
    {
      title: (
        <Tooltip className="whitespace-nowrap" title="Date of Raising (dd-mm-yyyy)">
          Date of Raising <br />
          (dd-mm-yyyy)
        </Tooltip>
      ),
      dataIndex: "created_at",
      key: "created_at",
      width: 70,
      ellipsis: true,
      render: (date, record) => {
        return (
          <span style={getTextStyle(record, darkMode)}>
            {formatIndianDate(date)}
          </span>
        );
      },
    },
    {
      title: (
        <Tooltip className="whitespace-nowrap" title="Agreement Type">
          Agreement Type
        </Tooltip>
      ),
      dataIndex: "agreement_type",
      width: 70,
      ellipsis: true,
      render: (text, record) => {
        return (
          <Tooltip title={text}>
            <div style={getTextStyle(record, darkMode)}
            >
              {limitWords(text, 12)}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: (
        <Tooltip className="whitespace-nowrap" title="Partner Name">
          Partner Name
        </Tooltip>
      ),
      dataIndex: "name_of_client",
      width: 80,
      ellipsis: true,
      render: (text, record) => {
        return (
          <span
            style={getTextStyle(record, darkMode)}
          >
            {text && limitWords(text, 18)}
          </span>
        );
      },
    },

    {
      title: (
        <Tooltip className="whitespace-nowrap" title="Nature">
          Nature
        </Tooltip>
      ),
      dataIndex: "nature",
      width: 60,
      ellipsis: true,
      render: (text, record) => {
        return (
          <span style={getTextStyle(record, darkMode)}>
            {text && text.charAt(0).toUpperCase() + text.slice(1)}
          </span>
        );
      },
    },
    {
      title: (
        <Tooltip className="whitespace-nowrap" title="Status">
          Status
        </Tooltip>
      ),
      dataIndex: "status",
      width: 70,
      ellipsis: true,
      render: (text, record) => {
        return (
          <span style={getTextStyle(record, darkMode)}>
            {capitalizeAndRemoveUnderscores(text)}
          </span>
        );
      },
    },
    // {
    //   title: (
    //     <Tooltip className="whitespace-nowrap" title="Remarks(if any)">
    //       <span>Remarks(if any)</span>
    //     </Tooltip>
    //   ),
    //   dataIndex: "remarks",
    //   width: 70,
    //   ellipsis: true,
    //   render: (text, record) => {
    //     return (
    //       <Tooltip title={text}>
    //         <div
    //           style={{
    //             overflow: "hidden",
    //             textOverflow: "ellipsis",
    //             whiteSpace: "nowrap",
    //             fontWeight: record.is_read ? "normal" : "bold",
    //              // Change color if unauthorized changes exist
    //           }}
    //         >
    //           {limitWords(text, 6)}
    //         </div>
    //       </Tooltip>
    //     );
    //   },
    // },
    // {
    //   title: (
    //     <Tooltip className="whitespace-nowrap" title="View details">
    //       View details
    //     </Tooltip>
    //   ),
    //   dataIndex: "first_name",
    //   key: "first_name",
    //   width: 70,
    //   ellipsis: true,
    //   render: (text, record) => <ViewDetail />,
    // },
  ], [selectedRowKeys, darkMode]);

  const handleSearch = (value) => {
    setSearchKeyword((val) => {
      val.search_keyword = value;
      return { ...val }
    })

  };

  const handleSwitchChange = (checked) => {
    setSearchKeyword((val) => {
      const updatedVal = { ...val, is_editor: checked };

      if (checked) {
        updatedVal.excuted = "Executed";
      } else {
        delete updatedVal.excuted;
      }

      return updatedVal;
    });
  };
  const getData = (data) => {
    setRequest(data);
  }
  const onPeding = (val) => {
    setIsloading(val)
  }
  const handleDownloadAll = () => {
    if (!request) {
      return false;
    }
    const csvData = request?.map(contract => ({
      "User Name": contract.user_name,
      "Date of Raising": formatIndianDate(contract.created_at),
      "Agreement Type": contract.agreement_type,
      "Partner Name": contract.name_of_client,
      "Nature": contract.nature,
      "Status": capitalizeAndRemoveUnderscores(contract.status),
      "Remarks": contract.remarks,
    }));

    const csv = Papa.unparse(csvData);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "contracts.csv";
    link.click();
    message.success("contracts details downloaded successfully")
  };
  const handelAgrDwn = async () => {
    const payload = {
      ...handleDataFromChild(),
      ...searchKeyword
    }
    try {
      const response = await axiosInstance.post(`/Download-all-agreement/`, payload);
      downloadFile(response.data.agreement_file_url, "downloaded_Agreement");
      message.success("agreement downloaded successfully")
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (location.state?.status === "EXECUTED" &&
      location.state?.month_name &&
      location.state?.year) {
      setListingUrl("/dashboard/executed_agreement_details_sumary/");
      setSearchKeyword({
        month_name: location.state.month_name,
        year: location.state.year,
        company_id: localStorage.getItem("companyId") || comp_id,
      });

    }
    else if (data) {
      setListingUrl('/contract/get/')
      setSearchKeyword({
        status: 'EXECUTED',
        month: data.split(' ')[0],
        year: data.split(' ')[1],
        is_active: "True",
        is_editor: false,
        company_id: localStorage.getItem("companyId") || comp_id
      })
    } else if (!!isFromAnaltticData && (location?.state?.product_name || location?.state?.payment_type)) {
      setListingUrl('/filter-agreements/');
      setSearchKeyword({
        status: 'EXECUTED',
        payment_type: location?.state?.payment_type,
        product: location?.state?.product_name,
        is_editor: false,
        search_keyword: '',
        company_id: localStorage.getItem("companyId") || comp_id
      })
    }
    else if (state?.user_id && state?.status) {
      setListingUrl('/contracts/user-filtered/');
      setSearchKeyword({
        user_id: state.user_id,
        status: state.status,
        search_keyword: ``,
        is_active: 'True',
        is_editor: false,
        company_id: localStorage.getItem("companyId") || comp_id
      });
    }
    else {
      setListingUrl('/contract/get/')
      setSearchKeyword({ search_keyword: '', search_filters: getSearchFilters(), is_active: "True", status: params?.status?.toUpperCase(), is_editor: false, company_id: localStorage.getItem("companyId") || comp_id })
    }
  }, [data, location]);

  return (

    <div className="my-[-3px]">
      <div className="mb-1 flex flex-row justify-between ">
        <div className="flex  items-center w-full">
          <h1 className="font-semibold text-[17px] dark:text-white"> Contracts </h1>
          <div className="ml-4 mr-2 flex justify-center items-center">
            {selectedRowKeys.length > 0 ? (
              <Tooltip title="Unread">
                <MailOutlined size={"small"}
                  className="text-xl transform pr-2 dark:text-white hover:scale-120 transition-transform duration-300 cursor-pointer"
                  onClick={handleIconClick}
                />
              </Tooltip>
            ) : (
              <div className="pr-7"></div>

            )}
          </div>
          <div className=" text-black relative  flex justify-right">
            <div className="relative mr-6 md:flex justify-between items-center gap-4">
              <div className="flex items-center gap-1">
                <CustomSearch onSearch={handleSearch} />
                <Tooltip title="Advanced Search Option">
                  <Button
                    type="primary"
                    icon={<FilterOutlined />}
                    onClick={() => setIsFilterOpen(prev => !prev)}
                  />
                </Tooltip>
                {isFilterOpen && (
                  <AdvancedSearchForm
                    searchFields={searchFields}
                    setSearchFields={setSearchFields}
                    handleAdvanceSearch={handleAdvanceSearch}
                    onClose={() => setIsFilterOpen(false)}
                  />
                )}
              </div>
              <div className="gap-4 mt-4 md:mt-0">
                {
                  params?.status !== "executed" && params?.status !== "transaction_closed" &&
                  <EditorSwitch initialState={false} state2={'All'} state1={'Editor'} isLoading={isLoading} handleSwitchChange={handleSwitchChange} />
                }
              </div>
            </div>
          </div>
        </div>
        <Link to={
          companyId
            ? `/admin/company/${companyId}/contracts/create_request`
            : `/admin/contracts/create_request`
        }>
          <MotionIconButton tooltip="Raise New Request" icon={<BoldPlusIcon />} onClick={() => { }} />
        </Link>
      </div>

      <div className="border border-gray-300">

        <Spin spinning={isLoading} tip="Loading...">
          <Table
            columns={columns}
            dataSource={request}
            scroll={{ x: 'max-content' }}
            className="text-[8px]  [&_.ant-table-cell]:text-[12px] dark:[&_.ant-table]:text-white dark:[&_.ant-table-cell]:text-white dark:[&_.ant-table-thead>tr>th]:text-white"
            tableLayout="fixed"
            size="small"
            style={{ color: darkMode ? "white" : "black", font: "120px" }}
            pagination={false}
            onRow={(record) => ({
              onClick: () => handleViewDetails(record),
              style: { cursor: "pointer" },
            })}
          />
        </Spin>
      </div>
      {!!listingUrl &&
        (data ? (Object.keys(searchKeyword).length > 4 && <Pnation onPeding={onPeding} onCngPage={getData} url={listingUrl} plod={searchKeyword} itmeName="Contracts" />) :
          isFromAnaltticData ? <Pnation onPeding={onPeding} onCngPage={getData} url={listingUrl} plod={searchKeyword} itmeName="Contracts" /> : <Pnation onPeding={onPeding} onCngPage={getData} url={listingUrl} plod={searchKeyword} itmeName="Contracts" />)
      }
      <div className="flex justify-center items-center gap-4 w-full ">
        <button
          onClick={handleDownloadAll}
          className="bg-[#36A34A] text-white px-4 py-2 text-sm mt-1.5 rounded-md border-0 cursor-pointer"
        >
          Download Contracts Details <DownloadOutlined />
        </button>
        <button
          className="bg-[#36A34A] text-white px-4 py-2 text-sm mt-1.5 rounded-md border-0 cursor-pointer"
          onClick={handelAgrDwn}
        >
          Download  Contracts Files <DownloadOutlined />
        </button>
      </div>
    </div>

  );
}

export default FreshRequest;
